import React from 'react';
import {
  Box,
  Typography,
  Paper,
  ButtonBase,
  Chip,
} from '@mui/material';
import type { DailyWorkerInsuranceNotice } from '../../lib/payroll/daily-worker-advisor';

interface DailyWorkerInsuranceAdvisorCardProps {
  notices: DailyWorkerInsuranceNotice[];
  onNoticeClick?: (notice: DailyWorkerInsuranceNotice) => void;
}

const DailyWorkerInsuranceAdvisorCard: React.FC<DailyWorkerInsuranceAdvisorCardProps> = ({
  notices,
  onNoticeClick,
}) => {
  if (notices.length === 0) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 2,
        borderRadius: 'var(--r-12)',
        border: '1px solid var(--border-default)',
        bgcolor: 'var(--bg-base)',
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5, color: 'var(--fg-strong)' }}>
        일당 4대보험 안내
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {notices.map((notice) => (
          <ButtonBase
            key={`${notice.employee.id}-${notice.kind}`}
            onClick={() => onNoticeClick?.(notice)}
            sx={{
              width: '100%',
              textAlign: 'left',
              borderRadius: 1.5,
              display: 'block',
            }}
          >
            <Box
              sx={{
                p: 1.5,
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: notice.isUrgent ? 'var(--c-orange-600)' : 'var(--border-subtle)',
                bgcolor: notice.isUrgent ? 'var(--c-red-50)' : 'var(--bg-elev-1)',
                '&:hover': { bgcolor: 'var(--bg-green)' },
              }}
            >
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, color: 'var(--fg-strong)' }}>
                      {notice.title}
                    </Typography>
                    <Chip
                      label={`${notice.workDays}일`}
                      size="small"
                      sx={{ height: 22, fontSize: '0.75rem' }}
                    />
                  </Box>
                  <Typography variant="body2" sx={{ color: 'var(--fg-secondary)', mt: 0.5 }}>
                    {notice.body}
                  </Typography>
                  {notice.amountSummary && (
                    <Typography variant="caption" sx={{ color: 'var(--fg-tertiary)', display: 'block', mt: 0.5 }}>
                      {notice.amountSummary}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </ButtonBase>
        ))}
      </Box>
    </Paper>
  );
};

export default DailyWorkerInsuranceAdvisorCard;
